import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {PaymentNotificationsComponent} from './payment-notifications.component';
import { TranslateModule } from '@ngx-translate/core';
import {
  MatBadgeModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCardModule,
  MatIconModule,
  MatProgressSpinnerModule, MatTooltipModule
} from '@angular/material';
import { BubbleMessageComponent } from './bubble-message/bubble-message.component';
import { PaymentContentComponent } from './payment-content/payment-content.component';
import { PaymentWindowComponent } from './payment-window/payment-window.component';
import { BubbleComponent } from './bubble-message/bubble/bubble.component';
import {NbButtonModule, NbCardModule, NbSpinnerModule} from '@nebular/theme';
import {FormsModule} from '@angular/forms';

@NgModule({
  declarations: [PaymentNotificationsComponent, BubbleMessageComponent, PaymentContentComponent, PaymentWindowComponent, BubbleComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatBadgeModule,
    MatIconModule,
    MatCardModule,
    NbCardModule,
    NbSpinnerModule,
    NbButtonModule,
    MatProgressSpinnerModule,
    MatButtonToggleModule,
    FormsModule,
    MatTooltipModule,
    TranslateModule
  ],
  exports: [
      PaymentNotificationsComponent
  ]
})
export class PaymentNotificationsModule { }
